// import React from "react";
// import { useEffect, useState, useRef } from "react";
// import { baseurladdress } from "../baseurl";
// import Sidennav from "../dashboard/sidenavbar";
// import Topnavbar from "../dashboard/topnavbar";
// import { NavLink, useNavigate } from "react-router-dom";
// import axios from "axios";

// function Adddailyshift() {
//   const accessuserid = localStorage.getItem("id");
//   const accesstoken = localStorage.getItem("token");
//   const navigate = useNavigate();
//   const Swal = require("sweetalert2");
//   const [branch, setBranch] = useState([]);
//   const [staffbranch, setStaffranch] = useState("");
//   const [stbranchanme, setstbranchanme] = useState("");
//   const [dept, setDept] = useState([]);
//   const [Staffdept, setStaffdept] = useState("");
//   const [deptnames, setDeptnames] = useState("");
//   const [deptcodes, setDeptcode] = useState("");
//   const [staffname, setStaffname] = useState([]);
//   const [staffids, setStaffids] = useState("");
//   const [staffnames, setStaffnames] = useState("");
//   const [staffcode, setStaffCode] = useState("");
//   const [staff_typeid, setstaff_typeid] = useState("");
//   const [staff_branchshift, setstaff_branchshift] = useState([]);
//   const [stype, setstype] = useState("");
//   const [stypename, setStypename] = useState("");
//   const [AllStaffDetails, setAllStaffDetails] = useState([]);
//   // const [datefrom, setdatefrom] = useState("");
//   const [datefrom, setdatefrom] = useState(() => {
//     const tomorrow = new Date();
//     tomorrow.setDate(tomorrow.getDate() + 1);
//     return tomorrow.toISOString().split("T")[0];
//   });

//   const [dateTo, setDateto] = useState("");
//   const toDateRef = useRef(null);

//   useEffect(() => {
//     getbranch();
//     getdept();
//   }, []);

//   // get all Branches
//   const getbranch = () => {
//     axios
//       .get(baseurladdress + `getallbranchs`, {
//         headers: { Authorization: `Bearer ${accesstoken}` },
//       })
//       .then((res) => {
//         const data = res.data.response;
//         // console.log(data);
//         const user = data.map((item, index) => {
//           return <option value={item.branch_id}> {item.branch_name} </option>;
//         });
//         setBranch(user);
//       })
//       .catch((error) => {
//         alert(error);
//       });
//   };

//   //get all department
//   const getdept = () => {
//     axios
//       .get(baseurladdress + `getalldepts`, {
//         headers: { Authorization: `Bearer ${accesstoken}` },
//       })
//       .then((res) => {
//         const data = res.data.response;
//         // console.log(data);
//         // const dept = data.map((item, index) => {
//         //   return <option value={item.dept_id}> {item.dept_name} </option>;
//         // });
//         setDept(data);
//       })
//       .catch((error) => {
//         alert(error);
//       });
//   };

//   useEffect(() => {
//     getshifttype();
//   }, []);

//   const getshifttype = (selectedShiftId) => {
//     axios
//       .get(baseurladdress + `getshifttype`, {
//         headers: { Authorization: `Bearer ${accesstoken}` },
//       })
//       .then((res) => {
//         const data = res.data.response;
//         const options = data.map((item) => ({
//           id: item.type_id,
//           name: item.type_name,
//         }));
//         setstaff_branchshift(options);
//         setstype(selectedShiftId);
//       })
//       .catch((error) => {
//         alert(error);
//       });
//   };

//   const getStaffdetails = (data) => {
//     if (staffbranch === "") {
//       Swal.fire({
//         toast: true,
//         position: "top-end",
//         icon: "error",
//         title: "Please choose a Branch",
//         showConfirmButton: false,
//         timer: 2500,
//         timerProgressBar: true,
//       });
//     } else {
//       axios
//         .get(
//           `${baseurladdress}getAllStaffBranchandDept/${staffbranch}/${data}`,
//           {
//             headers: { Authorization: `Bearer ${accesstoken}` },
//           }
//         )
//         // .then((res) => {
//         //   const data = res.data.response;
//         //   setAllStaffDetails(data);
//         //   setstype("");
//         //   const stffname = data.map((item) => (
//         //     <option key={item.staff_id} value={item.staff_id}>
//         //       {item.staff_name}
//         //     </option>
//         //   ));
//         //   setStaffname(stffname);
//         // })
//         // .catch((error) => {
//         //   alert(error);
//         // });

//         .then((res) => {
//           const data = res.data.response;

//           if (Array.isArray(data)) {
//             setAllStaffDetails(data);
//             setstype("");
//             const stffname = data.map((item) => (
//               <option key={item.staff_id} value={item.staff_id}>
//                 {item.staff_name}
//               </option>
//             ));
//             setStaffname(stffname);
//           } else {
//             // Handle when response is not an array
//             setAllStaffDetails([]);
//             setStaffname([]);
//             Swal.fire({
//               toast: true,
//               position: "top-end",
//               icon: "warning",
//               title: "No staff data found",
//               text: "The selected branch/department has no staff.",
//               showConfirmButton: false,
//               timer: 2500,
//               timerProgressBar: true,
//             });
//           }
//         });
//     }
//   };

//   useEffect(() => {
//     if (stype && staff_branchshift.length > 0) {
//       const selected = staff_branchshift.find(item => item.id == stype); 
//       if (selected) {
//         setStypename(selected.name);
//       }
//     }
//   }, [stype, staff_branchshift]);


//   const handleAddshiftAsgmnt = (e) => {
//     e.preventDefault();
//     if (datefrom == "") {
//       Swal.fire({
//         toast: true,
//         position: "top-end",
//         icon: "error",
//         title: "Please choose From date",
//         showConfirmButton: false,
//         timer: 2500,
//         timerProgressBar: true,
//       });
//     } else if (dateTo == "") {
//       Swal.fire({
//         toast: true,
//         position: "top-end",
//         icon: "error",
//         title: "Please choose To date",
//         showConfirmButton: false,
//         timer: 2500,
//         timerProgressBar: true,
//       });
//       toDateRef.current.focus();
//     } else {
//       var data = {
//         assign_staffid: staffids,
//         assign_staffname: staffnames,
//         assign_staffcode: staffcode,
//         assign_branchid: staffbranch,
//         assign_branchname: stbranchanme,
//         assign_deptid: Staffdept,
//         assign_deptname: deptnames,
//         assign_deptcode: deptcodes,
//         assign_shifttypeid: stype,
//         asign_shiftname: stypename,
//         assing_fromdate: datefrom,
//         assign_todate: dateTo,
//         assign_updby: accessuserid,
//       };
//       axios
//         .post(baseurladdress + `addshiftAssignment`, data, {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         })
//         .then((result) => {
//           console.log("reslt:", result);
//           const Data = result.data.status;
//           if (Data == "success") {
//             const Toast = Swal.mixin({
//               toast: true,
//               position: "top-end",
//               showConfirmButton: false,
//               timer: 2500,
//               timerProgressBar: true,
//               didOpen: (toast) => {
//                 toast.addEventListener("mouseenter", Swal.stopTimer);
//                 toast.addEventListener("mouseleave", Swal.resumeTimer);
//               },
//             });
//             Toast.fire({
//               icon: "success",
//               title: "Shift Data added successfully",
//             });
//             navigate("/shiftassignment");
//           } else {
//             alert("Failed");
//           }
//         })
//         .catch((error) => {
//           alert(error);
//         });
//     }
//   };

//   const getTomorrowDate = () => {
//     const tomorrow = new Date();
//     tomorrow.setDate(tomorrow.getDate() + 1);
//     return tomorrow.toISOString().split("T")[0];
//   };

//   return (
//     <div>
//       <Topnavbar />
//       <Sidennav />
//       <div
//         class="content-wrap"
//         style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
//       >
//         <div className="container-fluid">
//           <NavLink activeClassName="active-link" to={"/shiftassignment"}>
//             <div style={{ display: "flex" }}>
//               <a class="float">
//                 <i
//                   class="fa fa-arrow-left my-float"
//                   style={{ marginTop: "21px" }}
//                 ></i>
//               </a>
//             </div>
//           </NavLink>
//           <form>
//             <div className="row">
//               <div class="col-xl-12 col-xxl-12">
//                 <div class="card">
//                   <div class="card-header">
//                     <h4 class="card-title">ADD SHIFT ASSIGNMENT</h4>
//                   </div>
//                   <div class="card-body">
//                     <div class="basic-form mt-3">
//                       <div class="form-row">
//                         <div class="col-sm-4 mt-2 mt-sm-0">
//                           <h6>
//                             <span style={{ color: "red" }}>*</span> Branch
//                           </h6>
//                           <select
//                             className="form-control select"
//                             name="branch"
//                             onChange={(e) => {
//                               const selbranchName =
//                                 e.target.options[e.target.selectedIndex].text;
//                               setstbranchanme(selbranchName);
//                               setStaffranch(e.target.value);
//                             }}
//                             required
//                           >
//                             <option value="" disabled selected>
//                               Select Branch
//                             </option>
//                             {branch}
//                           </select>
//                         </div>

//                         <div class="col-sm-3 mt-2 mt-sm-0">
//                           <h6>
//                             <span style={{ color: "red" }}>*</span> Department
//                           </h6>
//                           <select
//                             className="form-control select"
//                             name="Department"
//                             onChange={(e) => {
//                               setStaffdept(e.target.value);
//                               getStaffdetails(e.target.value);
//                               const depidsss = parseInt(e.target.value);
//                               const seldepname =
//                                 e.target.options[e.target.selectedIndex].text;
//                               setDeptnames(seldepname);
//                               const selectedStaffcode = dept.find(
//                                 (depts) => depts.dept_id === depidsss
//                               );
//                               if (selectedStaffcode) {
//                                 setDeptcode(selectedStaffcode.dept_code);
//                               }
//                             }}
//                             required
//                           >
//                             <option value="" disabled selected>
//                               Select
//                             </option>
//                             {dept.map((item) => (
//                               <option key={item.dept_id} value={item.dept_id}>
//                                 {item.dept_name}
//                               </option>
//                             ))}
//                           </select>
//                         </div>
//                         <div className="col-sm-3 mt-2 mt-sm-0">
//                           <h6>
//                             <span style={{ color: "red" }}>*</span> Staff Name
//                           </h6>
//                           <select
//                             className="form-control select"
//                             name="staffname"
//                             onChange={(e) => {
//                               const selectedId = parseInt(e.target.value);
//                               const selectedName =
//                                 e.target.options[e.target.selectedIndex].text;
//                               setStaffids(selectedId);
//                               setStaffnames(selectedName);
//                               const selectedStaff = AllStaffDetails.find(
//                                 (staff) => staff.staff_id === selectedId
//                               );
//                               if (selectedStaff) {
//                                 getshifttype(selectedStaff.staff_branchshift);
//                                 setStaffCode(selectedStaff.staff_code);
//                               }
//                             }}
//                             required
//                           >
//                             <option value="" disabled selected>
//                               Select Staff Name
//                             </option>
//                             {staffname}
//                           </select>
//                         </div>
//                         <div className="col-sm-2 mt-2 mt-sm-0">
//                           <h6>Staff Code</h6>
//                           <input
//                             type="text"
//                             class="form-control"
//                             value={staffcode}
//                             readOnly
//                           />
//                         </div>

//                         <div className="col-sm-4 mt-2 mt-sm-0">
//                           <h6>Shift Type</h6>
//                           <select
//                             className="form-control select"
//                             name="Shifttype"
//                             value={stype}
//                             onChange={(e) => {
//                               setstype(e.target.value);
//                               const setStypenames =
//                                 e.target.options[e.target.selectedIndex].text;
//                               setStypename(setStypenames);
//                             }}
//                           >
//                             <option value="" disabled>
//                               Select
//                             </option>
//                             {staff_branchshift.map((item) => (
//                               <option key={item.id} value={item.id}>
//                                 {item.name}
//                               </option>
//                             ))}
//                           </select>
//                         </div>

//                         <div className="col-sm-4 mt-2 mt-sm-0">
//                           <h6>From Date</h6>
//                           <input
//                             type="date"
//                             className="form-control"
//                             required
//                             value={datefrom}
//                             onChange={(e) => setdatefrom(e.target.value)}
//                             min={datefrom}
//                           />
//                         </div>
//                         <div class="col-sm-4 mt-2 mt-sm-0">
//                           <h6>To Date</h6>
//                           <input
//                             type="date"
//                             class="form-control"
//                             required
//                             onChange={(e) => setDateto(e.target.value)}
//                             min={datefrom}
//                             ref={toDateRef}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div class="col-12 offset-6 mt-4">
//                     <button
//                       type="button"
//                       class="btn btn-primary mb-2"
//                       onClick={handleAddshiftAsgmnt}
//                     >
//                       SAVE
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Adddailyshift;
import React from "react";
import { useEffect, useState, useRef } from "react";
import { baseurladdress } from "../baseurl";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";

function Adddailyshift() {

  const accessuserid = localStorage.getItem("id");

  const accesstoken = localStorage.getItem("token");

  const navigate = useNavigate();

  const Swal = require("sweetalert2");

  // =====================================================
  // STATES
  // =====================================================

  const [branch, setBranch] = useState([]);

  const [staffbranch, setStaffranch] = useState("");

  const [stbranchanme, setstbranchanme] = useState("");

  const [dept, setDept] = useState([]);

  const [Staffdept, setStaffdept] = useState("");

  const [deptnames, setDeptnames] = useState("");

  const [deptcodes, setDeptcode] = useState("");

  const [staffname, setStaffname] = useState([]);

  const [staffids, setStaffids] = useState("");

  const [staffnames, setStaffnames] = useState("");

  const [staffcode, setStaffCode] = useState("");

  const [staff_branchshift, setstaff_branchshift] = useState([]);

  const [stype, setstype] = useState("");

  const [stypename, setStypename] = useState("");

  const [AllStaffDetails, setAllStaffDetails] = useState([]);

  const [datefrom, setdatefrom] = useState(() => {

    const tomorrow = new Date();

    tomorrow.setDate(tomorrow.getDate() + 1);

    return tomorrow.toISOString().split("T")[0];

  });

  const [dateTo, setDateto] = useState("");

  const toDateRef = useRef(null);

  // =====================================================
  // INITIAL LOAD
  // =====================================================

  useEffect(() => {

    getbranch();

    getdept();

    getshifttype();

  }, []);

  // =====================================================
  // GET BRANCH
  // =====================================================

  const getbranch = () => {

    axios
      .get(baseurladdress + `getallbranchs`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      })

      .then((res) => {

        setBranch(res.data.response || []);

      })

      .catch((error) => {

        console.log(error);

      });
  };

  // =====================================================
  // GET DEPARTMENT
  // =====================================================

  const getdept = () => {

    axios
      .get(baseurladdress + `getalldepts`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      })

      .then((res) => {

        setDept(res.data.response || []);

      })

      .catch((error) => {

        console.log(error);

      });
  };

  // =====================================================
  // GET SHIFT TYPES
  // =====================================================

  const getshifttype = (selectedShiftId = "") => {

    axios
      .get(baseurladdress + `getallshifttype`, {
        headers: {
          Authorization: `Bearer ${accesstoken}`,
        },
      })

      .then((res) => {

        const data = res.data.response || [];

        const options = data.map((item) => ({
          id: item.type_id,
          name: item.type_name,
        }));

        setstaff_branchshift(options);

        // AUTO SELECT SHIFT

        if (selectedShiftId) {

          const selected = options.find(
            (item) =>
              String(item.id) ===
              String(selectedShiftId)
          );

          if (selected) {

            setstype(selected.id);

            setStypename(selected.name);
          }
        }
      })

      .catch((error) => {

        console.log(error);

      });
  };

  // =====================================================
  // GET STAFF DETAILS
  // =====================================================

  const getStaffdetails = (deptid) => {

    if (staffbranch === "") {

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Please choose a Branch",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      });

      return;
    }

    axios
      .get(
        `${baseurladdress}getAllStaffBranchandDept/${staffbranch}/${deptid}`,
        {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
          },
        }
      )

      .then((res) => {

        const data = res.data.response || [];

        setAllStaffDetails(data);

        if (Array.isArray(data)) {

          setStaffname(data);

        } else {

          setStaffname([]);

        }
      })

      .catch((error) => {

        console.log(error);

      });
  };

  // =====================================================
  // SAVE SHIFT ASSIGNMENT
  // =====================================================

  const handleAddshiftAsgmnt = (e) => {

    e.preventDefault();

    // ==========================================
    // VALIDATION
    // ==========================================

    if (!staffbranch) {

      Swal.fire({
        icon: "warning",
        title: "Please Select Branch",
      });

      return;
    }

    if (!Staffdept) {

      Swal.fire({
        icon: "warning",
        title: "Please Select Department",
      });

      return;
    }

    if (!staffids) {

      Swal.fire({
        icon: "warning",
        title: "Please Select Staff",
      });

      return;
    }

    if (!stype) {

      Swal.fire({
        icon: "warning",
        title: "Please Select Shift Type",
      });

      return;
    }

    if (!datefrom) {

      Swal.fire({
        icon: "warning",
        title: "Please Select From Date",
      });

      return;
    }

    if (!dateTo) {

      Swal.fire({
        icon: "warning",
        title: "Please Select To Date",
      });

      toDateRef.current.focus();

      return;
    }

    // ==========================================
    // DATA
    // ==========================================

    const data = {

      assign_staffid: staffids,

      assign_staffname: staffnames,

      assign_staffcode: staffcode,

      assign_branchid: staffbranch,

      assign_branchname: stbranchanme,

      assign_deptid: Staffdept,

      assign_deptname: deptnames,

      assign_deptcode: deptcodes,

      assign_shifttypeid: stype,

      // IMPORTANT FIX
      asign_shiftname: stypename,

      assing_fromdate: datefrom,

      assign_todate: dateTo,

      assign_updby: accessuserid,
    };

    console.log("FINAL DATA :", data);

    axios
      .post(
        baseurladdress + `addshiftAssignment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
          },
        }
      )

      .then((result) => {

        console.log(result);

        if (result.data.status === "success") {

          Swal.fire({
            icon: "success",
            title: "Shift Data Added Successfully",
            timer: 2000,
            showConfirmButton: false,
          });

          navigate("/shiftassignment");

        } else {

          Swal.fire({
            icon: "error",
            title: "Failed",
          });
        }
      })

      .catch((error) => {

        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Server Error",
        });
      });
  };

  // =====================================================
  // UI
  // =====================================================

  return (

    <div>

      <Topnavbar />

      <Sidennav />

      <div
        className="content-wrap"
        style={{
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >

        <div className="container-fluid">

          <NavLink
            activeClassName="active-link"
            to={"/shiftassignment"}
          >

            <div style={{ display: "flex" }}>

              <a className="float">

                <i
                  className="fa fa-arrow-left my-float"
                  style={{ marginTop: "21px" }}
                ></i>

              </a>

            </div>

          </NavLink>

          <form>

            <div className="row">

              <div className="col-xl-12 col-xxl-12">

                <div className="card">

                  <div className="card-header">

                    <h4 className="card-title">
                      ADD SHIFT ASSIGNMENT
                    </h4>

                  </div>

                  <div className="card-body">

                    <div className="basic-form mt-3">

                      <div className="form-row">

                        {/* BRANCH */}

                        <div className="col-sm-4 mt-2">

                          <h6>
                            <span style={{ color: "red" }}>
                              *
                            </span>{" "}
                            Branch
                          </h6>

                          <select
                            className="form-control"
                            value={staffbranch}
                            onChange={(e) => {

                              const branchId =
                                e.target.value;

                              const branchName =
                                e.target.options[
                                  e.target.selectedIndex
                                ].text;

                              setStaffranch(branchId);

                              setstbranchanme(branchName);
                            }}
                          >

                            <option value="">
                              Select Branch
                            </option>

                            {branch.map((item) => (

                              <option
                                key={item.branch_id}
                                value={item.branch_id}
                              >
                                {item.branch_name}
                              </option>

                            ))}

                          </select>

                        </div>

                        {/* DEPARTMENT */}

                        <div className="col-sm-4 mt-2">

                          <h6>
                            <span style={{ color: "red" }}>
                              *
                            </span>{" "}
                            Department
                          </h6>

                          <select
                            className="form-control"
                            value={Staffdept}
                            onChange={(e) => {

                              const deptId =
                                e.target.value;

                              const deptName =
                                e.target.options[
                                  e.target.selectedIndex
                                ].text;

                              setStaffdept(deptId);

                              setDeptnames(deptName);

                              getStaffdetails(deptId);

                              const selectedDept =
                                dept.find(
                                  (item) =>
                                    String(item.dept_id) ===
                                    String(deptId)
                                );

                              if (selectedDept) {

                                setDeptcode(
                                  selectedDept.dept_code
                                );
                              }
                            }}
                          >

                            <option value="">
                              Select Department
                            </option>

                            {dept.map((item) => (

                              <option
                                key={item.dept_id}
                                value={item.dept_id}
                              >
                                {item.dept_name}
                              </option>

                            ))}

                          </select>

                        </div>

                        {/* STAFF */}

                        <div className="col-sm-4 mt-2">

                          <h6>
                            <span style={{ color: "red" }}>
                              *
                            </span>{" "}
                            Staff Name
                          </h6>

                          <select
                            className="form-control"
                            value={staffids}
                            onChange={(e) => {

                              const selectedId =
                                e.target.value;

                              const selectedName =
                                e.target.options[
                                  e.target.selectedIndex
                                ].text;

                              setStaffids(selectedId);

                              setStaffnames(selectedName);

                              const selectedStaff =
                                AllStaffDetails.find(
                                  (staff) =>
                                    String(staff.staff_id) ===
                                    String(selectedId)
                                );

                              if (selectedStaff) {

                                setStaffCode(
                                  selectedStaff.staff_code
                                );

                                // IMPORTANT FIX

                                getshifttype(
                                  selectedStaff.staff_branchshift
                                );
                              }
                            }}
                          >

                            <option value="">
                              Select Staff
                            </option>

                            {staffname.map((item) => (

                              <option
                                key={item.staff_id}
                                value={item.staff_id}
                              >
                                {item.staff_name}
                              </option>

                            ))}

                          </select>

                        </div>

                        {/* STAFF CODE */}

                        <div className="col-sm-4 mt-2">

                          <h6>Staff Code</h6>

                          <input
                            type="text"
                            className="form-control"
                            value={staffcode}
                            readOnly
                          />

                        </div>

                        {/* SHIFT */}

                        <div className="col-sm-4 mt-2">

                          <h6>
                            <span style={{ color: "red" }}>
                              *
                            </span>{" "}
                            Shift Type
                          </h6>

                          <select
                            className="form-control"
                            value={stype}
                            onChange={(e) => {

                              const shiftId =
                                e.target.value;

                              const shiftName =
                                e.target.options[
                                  e.target.selectedIndex
                                ].text;

                              setstype(shiftId);

                              setStypename(shiftName);
                            }}
                          >

                            <option value="">
                              Select Shift
                            </option>

                            {staff_branchshift.map((item) => (

                              <option
                                key={item.id}
                                value={item.id}
                              >
                                {item.name}
                              </option>

                            ))}

                          </select>

                        </div>

                        {/* FROM DATE */}

                        <div className="col-sm-4 mt-2">

                          <h6>From Date</h6>

                          <input
                            type="date"
                            className="form-control"
                            value={datefrom}
                            min={datefrom}
                            onChange={(e) =>
                              setdatefrom(
                                e.target.value
                              )
                            }
                          />

                        </div>

                        {/* TO DATE */}

                        <div className="col-sm-4 mt-2">

                          <h6>To Date</h6>

                          <input
                            type="date"
                            className="form-control"
                            value={dateTo}
                            min={datefrom}
                            ref={toDateRef}
                            onChange={(e) =>
                              setDateto(
                                e.target.value
                              )
                            }
                          />

                        </div>

                      </div>

                    </div>

                  </div>

                  {/* SAVE BUTTON */}

                  <div className="col-12 offset-5 mt-4 mb-4">

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAddshiftAsgmnt}
                    >
                      SAVE
                    </button>

                  </div>

                </div>

              </div>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}

export default Adddailyshift;